export { default as RatingReviews } from './RatingReviews';
export * from './RatingReviewPlaceholder';
